import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from "rxjs/internal/Observable";
import {config} from "../../config";
import {inject} from "@angular/core";
import {from} from "rxjs/internal/observable/from";
import {SessionIdRouteParam} from "../networking";
import {MessageCode} from "@mindpath/shared";
import {switchMap} from "rxjs/internal/operators/switchMap";
import {AuthService} from "./auth.service";

export const tokenInjectionInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const url = new URL(req.url);
  // if not hitting the finder endpoints don't do anything
  if (!url.pathname.startsWith('/api/finder')) {
    return next(req);
  }

// if the request is not to localdev or the api, or to the initial finder endpoint, return
// this is to prevent the auth token from being sent to other domains and so we get a fresh token
  if ((location.host !== 'localhost:4200' && url.origin !== config.endpoints.api)) {
    return next(req);
  }

  const auth = inject(AuthService);
  const authData = auth.data();
// check if it's the token create/refresh endpoints
  if (url.pathname === '/api/finder' && (req.method === 'POST' || req.method === 'PUT')) {
    return next(req);
  }

  const session = authData?.session;
// check if it's the token create/refresh endpoints
  if (session?.id && url.pathname === `/api/finder/${session.id}` && req.method === 'GET') {
    return next(req);
  }

  return from((async () => {

    const session = authData!.session!;
    let token: string | undefined = session.auth.token;
    if (url.pathname.endsWith('/verification')) {
      token = authData?.intake?.otp?.auth?.token;
    } else if (url.pathname.includes('/attachments') || url.pathname.includes('/hold')) {
      token = authData?.intake?.auth?.token;
    } else if (url.pathname.includes('/appointments') && req.method === 'PUT') {
      token = authData?.intake?.auth?.token;
    }

    if (req.url.includes(SessionIdRouteParam)) {
      req = req.clone({
        url: req.url.replace(SessionIdRouteParam, authData!.session!.id),
      });
    }

    if (!token) {
      return MessageCode.ATH0005.throw();
    }


    return req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });

  })())
    .pipe(switchMap(next));

};
